import React, { useState } from 'react';
import axios from 'axios';
import { fetchAuthSession } from '@aws-amplify/auth';
import SERVICE_API_URL from '../serviceUrl';

const Offers = () => {
  const [offerId, setOfferId] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);
  const [result, setResult] = useState(null);

  const formatDate = (value) => {
    if (!value) return 'No end date';
    return new Date(value).toLocaleDateString('en-IN', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  const extractErrorMessage = (subscribeError) => {
    const data = subscribeError.response?.data;
    return data?.message || data?.detail || 'Unable to apply this offer right now.';
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const trimmedOfferId = offerId.trim();
    if (!trimmedOfferId) {
      setError('Please enter an offer ID.');
      setResult(null);
      return;
    }

    setSubmitting(true);
    setError(null);
    setResult(null);

    try {
      const session = await fetchAuthSession();
      const idToken = session.tokens?.idToken?.toString();

      const response = await axios.post(
        `${SERVICE_API_URL}/prep/offers/subscribe`,
        { offerId: trimmedOfferId },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${idToken}`
          }
        }
      );

      setResult(response.data);
      setOfferId('');
    } catch (subscribeError) {
      console.error('Error applying offer:', subscribeError);
      setError(extractErrorMessage(subscribeError));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container">
      <div className="section-header">
        <h1 className="section-title">Offers</h1>
        <div className="section-subtitle">
          Enter an offer ID to unlock free or discounted access to assessments.
        </div>
      </div>

      <div className="card" style={{
        maxWidth: 520,
        margin: '0 auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--spacing-md)'
      }}>
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
          <input
            id="offerId"
            name="offerId"
            type="text"
            value={offerId}
            onChange={(event) => setOfferId(event.target.value)}
            placeholder="Enter offer ID"
            aria-label="Offer ID"
            autoComplete="off"
            disabled={submitting}
            className="input"
            style={{ backgroundColor: 'var(--surface)' }}
          />
          <button
            type="submit"
            className="button"
            disabled={submitting}
            style={{ width: '100%' }}
          >
            {submitting ? 'Applying...' : 'Apply offer'}
          </button>
        </form>

        {error && (
          <div style={{
            border: '1px solid var(--error)',
            backgroundColor: 'var(--error-light)',
            color: 'var(--error)',
            borderRadius: 'var(--radius-md)',
            padding: '10px 14px'
          }}>
            {error}
          </div>
        )}

        {result && (
          <div style={{
            borderRadius: 'var(--radius-md)',
            padding: '10px 14px',
            backgroundColor: 'var(--success-light)',
            color: 'var(--success)',
            fontWeight: 600
          }}>
            <div>{result.message || 'Offer applied successfully.'}</div>
            {result.title && (
              <div style={{ marginTop: 6, fontWeight: 500 }}>
                {result.title}
                {result.validUntil ? ` · Active until ${formatDate(result.validUntil)}` : ''}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Offers;
